<template>
  <right-layout>
    <div class='body'>
      <div class="headerDiv">
        <div class='bodyContext' style="position: relative;">
          <div class='titile F3-M-27'>ルート編集</div>
        </div>
      </div>

      <div class="contentDiv slider">
        <div class="req">※ 必須項目</div>
        <!-- 運行区分、アプリ -->
        <div style="display: flex; flex-direction: row;">
          <!-- 運行区分 -->
          <div class='bodyContext info' style="width:50%">
            <div class='label' style="flex:3.7; position: relative;">
              <span class="icon">※</span>
              <div>
                <span>運行区分</span>
              </div>
            </div>
            <div class='context' style="flex:10">
              <div class='radioDiv' style="width:100%; display: flex; align-items: center; line-height: 40px;">
                <label class="radio-inline" style="margin-right: 4%">
                  <input class="radiobutton" type="radio" name="transportKindRadio" v-model="routeInfo.transportKind" value="0">
                  <span></span>
                  <span class="F3-R-20">区域内</span>
                </label>
                <label class="radio-inline">
                  <input class="radiobutton" type="radio" name="transportKindRadio" v-model="routeInfo.transportKind" value="1">
                  <span></span>
                  <span class="F3-R-20">区域外</span>
                </label>
              </div>
            </div>
          </div>
          <!-- ドライバーアプリ端末 -->
          <div class='bodyContext info' style="width:50%">
            <div class='label' style="flex:3.7; position: relative;">
              <!-- <span class="icon">※</span> -->
              <div>
                <span>ドライバーアプリ端末</span>
              </div>
            </div>
            <div class='context' style="flex:10">
              <div class='radioDiv' style="width:100%; display: flex; align-items: center; line-height: 40px;">
                <!-- <label class="radio-inline" style="margin-right: 4%; display: none">
                  <input class="radiobutton" type="radio" name="driverAppRadio" v-model="routeInfo.routeType" value="0">
                  <span></span>
                  <span class="F3-R-20">区域内</span>
                </label> -->
                <label class="radio-inline" style="margin-right: 4%">
                  <input class="radiobutton" type="radio" name="driverAppRadio" v-model="routeInfo.routeType" value="1" :disabled="routeInfo.transportKind==0">
                  <span></span>
                  <span class="F3-R-20">使用する</span>
                </label>
                <label class="radio-inline">
                  <input class="radiobutton" type="radio" name="driverAppRadio" v-model="routeInfo.routeType" value="2" :disabled="routeInfo.transportKind==0">
                  <span></span>
                  <span class="F3-R-20">使用しない</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      
        <div class='bodyContext info'>
          <div class='label' style="position: relative;">
            <span class="icon">※</span>
            <div>
              <span>ルート名</span>
            </div>
          </div>
          <div class='context'>
            <input type='text' name='routeName' maxlength="40" v-validate="'required|paintWordNo'" v-model="routeInfo.routeName" class='inputstyles' />
          </div>
        </div>
        <!-- 路名 -->
        <div class="bodyContext" style="height:25px;" v-show="errors.has('routeName')" >
          <div class='label' style="height:100%;background-color: #ffffff;"></div>
          <div class='context' style="height:100%;padding-left:10px;">
            <span class="errorMessage">{{ errors.first('routeName') }}</span>
          </div>
        </div>

        <div class='bodyContext info'>
          <div class='label'>
            <div>
              <span>ルートID</span>
            </div>
          </div>
          <div class='context'>
            <div class="contextColumn1 idClass">
              <div> {{ routeInfo.displayRouteId }} </div>
            </div>
          </div>
        </div>

        <!-- 出発地停留所 -->
        <div class='bodyContext info'>
          <div class='label'>
            <span class="icon">※</span>
            <div>
              <span>出発地</span>
            </div>
          </div>
          <div class='context'>
            <div class="contextColumn1">
              <select v-model="startRouteInfo" class='selectId' name='startRoute' v-validate="'required'" @change="selectChange(startRouteInfo, 'start')">
                <option :value='item' v-for="(item, index) in stationDataList" :key="index" v-show="item.transportKind == routeInfo.transportKind">
                  {{ item.officeFlag===1?"【事務所】":""}}
                  {{ item.stationName }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <!-- 出发地下拉框验证 -->
        <div class="bodyContext" style="height:25px;" v-show="errors.has('startRoute')" >
          <div class='label' style="height:100%;background-color: #ffffff;"></div>
          <div class='context'>
            <!-- <span class="errorMessage">{{errors.first('startRoute')}}</span> -->
            <span class="errorMessage">出発地を選択してください。</span>
          </div>
        </div>
        <div class="bodyContext" style="height:25px;" v-show="startRouteDuplicateFlag">
          <div class='label' style="height:100%;background-color: #ffffff;"></div>
          <div class='context' style="height:100%;padding-left: 10px;">
            <span class="errorMessage">同じ停留所を複数回使用することはできません。</span>
          </div>
        </div>

        <!-- 中间停留点 -->
        <div v-for="(item, index) in passRouteListComp" :key="index">
          <div class='bodyContext info'>
            <div class='label'>
              <div>
                <span> 停留所 {{ index + 1 }} </span>
              </div>
            </div>
            <div class='context'>
              <div class="contextColumn1">
                <select class='selectId' :name='`stationid${item.routeNo}`' v-validate="{required: item.stationId ? checkRoute = false: checkRoute = true}" v-model="item.stationId" @change="selectChange(item, 'passRoute')">
                  <option :value='o.stationId' v-for="(o, i) in stationDataList" :key="i" v-show="(o.transportKind == routeInfo.transportKind) && (o.officeFlag === 0)">
                    <div class="scrollbar" style="margin-left:10px">
                      {{ o.stationName }}
                    </div>
                  </option>
                </select>
                <template v-if="true">
                  <div class="clear" @click="delSinglReoute(index)">
                    <div class="clearIcon"></div>
                  </div>
                </template>
              </div>
              <template v-if="passRouteListComp.length >= 2">
                <div class="contextColumn2">
                  <template v-if="index === 0">
                    <div>
                      <div class="controlButton">
                        <img src="../../assets/button/list_up_button2.png" alt="">
                      </div>
                      <div class="controlButton" @click="downData(passRouteListComp, index)">
                        <img src="../../assets/button/list_down_button1.png" alt="">
                      </div>
                    </div>
                  </template>
                  <template v-if='index && index !== 0 && index !== passRouteListComp.length - 1'>
                    <div>
                      <div class="controlButton" @click="upData(passRouteListComp, index)">
                        <img src="../../assets/button/list_up_button1.png" alt="">
                      </div>
                      <div class="controlButton" @click="downData(passRouteListComp, index)">
                        <img src="../../assets/button/list_down_button1.png" alt="">
                      </div>
                    </div>
                  </template>
                  <template v-if='index === passRouteListComp.length - 1'>
                    <div>
                      <div class="controlButton" @click="upData(passRouteListComp, index)">
                        <img src="../../assets/button/list_up_button1.png" alt="">
                      </div>
                      <div class="controlButton">
                        <img src="../../assets/button/list_down_button2.png" alt="">
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </div>
          <div class="bodyContext" style="height:25px;" v-show="errors.has(`stationid${item.routeNo}`)">
            <div class='label' style="height:100%;background-color: #ffffff;"></div>
            <div class='context' style="height:100%;padding-left: 10px;">
              <span class="errorMessage">停留所を選択してください。</span>
            </div>
          </div>
          <div class="bodyContext" style="height:25px;" v-show="item.isDuplicated">
            <div class='label' style="height:100%;background-color: #ffffff;"></div>
            <div class='context' style="height:100%;padding-left: 10px;">
              <span class="errorMessage">同じ停留所を複数回使用することはできません。</span>
            </div>
          </div>
        </div>

        <!-- 中间的图标div -->
        <div class='bodyContext add'>
          <div @click="addRoute">
            <!-- 圆圈 -->
            <div class='addIcon bgc6' style="cursor:pointer">
              <div style="font-size:2em;color:#fff">
                +
              </div>
            </div>
            <!-- 字体 -->
            <div class='addFontSize' style="cursor:pointer">
              <div><p style="margin:auto 0;letter-spacing:5px;font-weight: 600; color:#707070">経由地追加</p></div>
            </div>
          </div>
        </div>

        <div class='bodyContext info'>
          <div class='label' style="position: relative;">
            <span class="icon">※</span>
            <div>
              <span>終着地</span>
            </div>
          </div>
          <div class='context'>
            <div class="contextColumn1">
              <select v-model="destinationInfo" class='selectId' style='flex:4' name='endRoute' v-validate="'required'" @change="selectChange(destinationInfo, 'destination')">
                <option :value='item' v-for="(item, index) in stationDataList" :key="index" v-show="item.transportKind == routeInfo.transportKind">
                  {{ item.officeFlag===1?"【事務所】":""}}
                  {{ item.stationName }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <!-- 终点地下拉框验证 -->
        <div class="bodyContext" style="height:25px;" v-show="errors.has('endRoute')" >
          <div class='label' style="height:100%;background-color: #ffffff;"></div>
          <div class='context' style="height:100%;">
            <span class="errorMessage">終着地を選択してください。</span>
          </div>
        </div>
        <div class="bodyContext" style="height:25px;" v-show="destinationRouteDuplicateFlag" >
          <div class='label' style="height:100%;background-color: #ffffff;"></div>
          <div class='context' style="height:100%;padding-left: 10px;">
            <span class="errorMessage">同じ停留所を複数回使用することはできません。</span>
          </div>
        </div>

        <!-- 八一卜距离、八一卜所用时间 -->
        <div style="display: flex; flex-direction: row;">
          <!-- 八一卜距离 -->
          <div class='bodyContext info' style="width:50%">
            <div class='label' style="flex:3.7">
              <div>
                <span>ルート距離</span>
              </div>
            </div>
            <div class='context' style="flex:10">
              <div class='idClass' style="width:100%">
                <div> {{ routeInfo.routeDistance | distanceFormatter }} </div>
              </div>
            </div>
          </div>
          <!-- 八一卜所用时间 -->
          <div class='bodyContext info' style="width:50%">
            <div class='label' style="flex:3.7">
              <div>
                <span>ルート所要時間</span>
              </div>
            </div>
            <div class='context' style="flex:10">
              <div class='idClass' style="width:100%">
                <div> {{ routeInfo.routeTotalTime | timeFormatter }} </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 地图 -->
        <div class='gooleMap'>
          <google-map ref='gMap' :center-point='centerPoint' :map-id='mapId' :point-list='pointDataList'>
          </google-map>
        </div>
      </div>

      <div class="foot">
        <div>
          <button class="foot-btn btn" data-toggle="modal" href="#modal-container-newLogin" style="cursor:pointer" @click="saveRouter()" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
            <span class="F2-M-24">保 存</span>
          </button>
        </div>
        <div>
          <button class="foot-btn btn" style="cursor:pointer" @click="$router.go(-1)">
            <span class="F2-M-24">キャンセル</span>
          </button>
        </div>
      </div>
    </div>
    <v-dialog v-show="showDialogRouter" :dialog-option="dialogOptionRouter" ref="dialogRouter"></v-dialog>
    <new-login-confirm v-if="show"></new-login-confirm>
  </right-layout>
</template>

<script>
import RightLayout from '@/router/layouts/rightLayout'
import newLoginConfirm from '@/components/NewLoginConfirm'
import googleMap from '@/components/googleMap'
import STATION_ICON from '@/assets/map_icon/map_stop_point1.png'
import STATION_ICON_FIRST from '@/assets/map_icon/map_transit_point1.png'
import dialog from '@/components/Dialog'
import _ from 'lodash'

export default {
  name: 'editRouterInfo',
  components: {
    RightLayout,
    googleMap,
    newLoginConfirm,
    'v-dialog': dialog
  },
  data () {
    return {

      // 验证
      checkRoute: false,
      mapId: 'editRouteMapID',
      centerPoint: {
        // lat: 35.661041,
        // lng: 139.87307
        lat: null,
        lng: null
      },
      // 下拉列表
      stationDataList: [],
      // 路信息对象
      routeInfo: {},
      // 出发地下拉框对象
      startRouteInfo: {},
      // 终点地下拉框对象
      destinationInfo: {},

      // 开始地集合
      startRouteList: [],
      // 经过地集合
      passRouteList: [],
      // 终点地集合
      destinationRouteList: [],

      num: 1,
      routeList: [],

      // 最终所有坐标点集合 开始 + 经过地 + 终点地
      pointList: [],

      // 地图标记点集合包含图标
      pointDataList: [],
      markList: [],
      totalDistance: null,
      totalTime: null,
      // 初始化组件为false
      show: false,
      // 添加或者修改的标识符
      flag: 'edit',
      //   弹出框
      showDialogRouter: false,
      dialogOptionRouter: {
        showNo: false,
        text: '事務所だけでルートを登録することはできません。',
        confirmButtonText: '確認'
      },
      duplicateStationIdList: [],
      startRouteDuplicateFlag: false,
      destinationRouteDuplicateFlag: false,
      // ルートに停留所が１つもない時のエラー
      stationCountError: false,
      stationCountErrorMessage: '事務所だけでルートを登録することはできません。<br>事務所以外の停留所を1つ以上含めてください。',
      // ルートに不正な停留所が含まれている時のエラー
      illegalStationError: false,
      illegalStationErrorMessage: '車で移動できない停留所が含まれています。<br>マップ上にルートが表示されるように停留所を選択してください。'
    }
  },
  async created () {
  },
  beforeMount () {
  },
  async mounted () {
    await this.loadData()
    this.setMarkAndLine(this.routeList)
  },
  computed: {
    passRouteListComp () {
      return this.passRouteList
    }
  },
  watch: {
    // 监听数组 pointList (数组改变重新获取数据)
    'pointList' (newVal) {
      if (newVal.length > 1) {
        this.setMarkAndLine(newVal)
      }
    },
    // 運行区分選択が区域内のときはドライバーアプリ端末のチェックを退避する
    'routeInfo.transportKind' (newvalue){

      // 停留所選択リセット
      this.startRouteInfo = null
      this.destinationInfo = null
      this.passRouteList.forEach(e => e.stationId = null)
      this.routeInfo.routeDistance = null
      this.routeInfo.routeTotalTime = null
      this.$refs.gMap.initializeGoogleMap()
      this.startRouteList = []
      this.passRouteList = []
      this.destinationRouteList = []
       
      if(newvalue == 0){
        this.routeInfo.routeType = '1'
      }
      
      // 重複フラグリセット
      this.duplicateStationIdList = []
      this.startRouteDuplicateFlag = false
      this.destinationRouteDuplicateFlag = false
    }
  },
  methods: {
    async loadData () {
      // 当前路 的信息
      let routeInfo = this.routeInfo = JSON.parse(sessionStorage.getItem('clickRoute')) || {}
      try {
        const {data, status, statusText} = await this.$axios.get('route/getAllStationData')
        if (status !== 200) throw new Error(statusText)
        this.stationDataList = data.stationDataList

        // 调用Lodash库方法筛选 符合的条件
        // 地域外交通対応時 順番変更
        this.routeList = _.map(routeInfo.routePassPointList, (o, i) => ({
          ...o,
          lat: (_.find(this.stationDataList, {stationId: o.stationId})).stationLat,
          lng: (_.find(this.stationDataList, {stationId: o.stationId})).stationLng
        }))

        // 把数组里每一项拿出来跟 <出发地> 和 <终点地> 匹经纬度，如果成功把数组里每一项添加到 对象里
        // 緯度経度が一致する停留所を参照していたが、同じ緯度経度の停留所が複数あるとバグるため、停留所IDを参照するように変更
        // 緯度経度を参照していた理由は不明
        this.stationDataList.some(item => {
          // if (item.stationLng === routeInfo.startLng && item.stationLat === routeInfo.startLat) {
          //   this.startRouteInfo = item
          // } else if (item.stationLng === routeInfo.endLng && item.stationLat === routeInfo.endLat) {
          //   this.destinationInfo = item
          // }
          if(this.routeList[0].stationId === item.stationId){
            this.startRouteInfo = item
          }
          if(this.routeList[this.routeList.length - 1].stationId === item.stationId){
            this.destinationInfo = item
          }
        })
        // 初始化
        // 往数组里添加出发地
        this.startRouteList.push(this.routeList[0])
        // 除去数组里面的开头和结尾，拿到中间的数组
        this.passRouteList = this.routeList.slice(1, -1)
        // 往数组里添加终点地
        this.destinationRouteList.push(this.routeList[this.routeList.length - 1])
      } catch (err) {
        console.log(err.statusText)
      }
    },
    // 初始化地图 并且给定图标和路线
    setMarkAndLine (pointList) {
      // 过滤假值
      let arrs = pointList.filter(o => {
        if (o.lng && o.lat) return o
      })
      new Promise((resolve) => {
        let index = 0
        this.pointDataList = []
        for (let i of arrs) {
          index += 1
          let p
          if ((index - 1) === 0) p = 'S'
          else if ((index - 1) === (arrs.length - 1)) p = 'G'
          else p = `${index - 1}`
          this.pointDataList.push({
            stationId: p,
            stationLat: i.lat,
            stationLng: i.lng,
            icon: p === 'S' ? STATION_ICON_FIRST : STATION_ICON
          })
        }
        resolve()
      }).then(() => {
        this.$refs.gMap.initializeGoogleMap().then(() => {
          this.$refs.gMap.map.setZoom(14)
          // 绘制路线并且 计算里程和时间
          this.$refs.gMap.plannRoute(arrs).then(res => {
            this.illegalStationError = false
            const { totalDistance, totalTime } = res[res.length - 1]
            this.routeInfo.routeTotalTime = totalTime || ''
            this.routeInfo.routeDistance = totalDistance || ''
            // 添加图标 并在 组件中监听事件
            if (this.pointDataList.length !== 0) {
              this.$refs.gMap.pointList = this.pointDataList
              // 添加图标
              let imgSize = {width: 45, height: 60}
              // 图标里面的字体样式
              let labelAnchor = {width: 25, height: 53}
              this.markList = this.$refs.gMap.addMark(imgSize, 'route-label-class', labelAnchor)
            }
          }).catch(err => {
            this.illegalStationError = true
            console.log(err)
          })
        })
      })
    },
    // 添加停留所
    addRoute () {
      // 获取开始和经过地数组
      let startAndPassTotal = this.startRouteList.concat(this.passRouteList)
      // 往经过数组里添加信息
      this.passRouteList.push({ routeId: this.routeInfo.routeId, routeNo: startAndPassTotal.length, stationId: null, lat: null, lng: null })
      // 往终了地 routeNo字段 + 1
      if(this.destinationRouteList.length > 0){
        this.destinationRouteList[0].routeNo = startAndPassTotal.length + 1
      }
    },
    // 删除单个停留所
    delSinglReoute (index) {
      this.checkRoute = false
      // 去除经由地信息
      this.passRouteList.splice(index, 1)
      // 经由地数组长度大于0
      if (this.passRouteList.length > 0) {
        let startAndPassTotal = this.startRouteList.concat(this.passRouteList)
        // 如果下标是当前数组长度
        if (index === this.passRouteList.length) {
          this.passRouteList[this.passRouteList.length - 1].routeNo = this.passRouteList.length
        } else {
          for (const i of this.passRouteList) {
            if (i.routeNo > index + 1) {
              i.routeNo = i.routeNo - 1
            }
          }
        }
        if(this.destinationRouteList.length > 0){
          this.destinationRouteList[0].routeNo = startAndPassTotal.length
        }
        this.pointList = this.routeInfo.routePassPointList = this.startRouteList.concat(this.passRouteList, this.destinationRouteList)
        this.checkStationDuplicate()
      } else {
        if(this.destinationRouteList.length > 0){
          this.destinationRouteList[0].routeNo = 1
        }
        this.pointList = this.routeInfo.routePassPointList = this.startRouteList.concat(this.destinationRouteList)
        this.checkStationDuplicate()
      }
    },
    // 向上移动
    upData (passRouteList, index) {
      this.checkRoute = false
      // 把arr 复制到另一个数组里 防止 操作同一个引用
      let passRouteLists = Object.assign([], passRouteList)
      if (passRouteLists.length > 1 && index !== 0) {
        // 属性值
        let temp = {}
        temp.stationId = passRouteLists[index].stationId
        temp.lat = passRouteLists[index].lat
        temp.lng = passRouteLists[index].lng
        passRouteLists[index].stationId = passRouteLists[index - 1].stationId
        passRouteLists[index].lat = passRouteLists[index - 1].lat
        passRouteLists[index].lng = passRouteLists[index - 1].lng
        passRouteLists[index - 1].stationId = temp.stationId
        passRouteLists[index - 1].lat = temp.lat
        passRouteLists[index - 1].lng = temp.lng
        this.passRouteList = passRouteLists
        this.pointList = this.routeInfo.routePassPointList = this.startRouteList.concat(this.passRouteList, this.destinationRouteList)
      }
    },
    // 向下移动
    downData (passRouteList, index) {
      this.checkRoute = false
      // 把arr 复制到另一个数组里 防止 操作同一个引用
      let passRouteLists = Object.assign([], passRouteList)
      if (passRouteLists.length > 1 && index !== passRouteLists.length - 1) {
        // 属性值
        let temp = {}
        temp.stationId = passRouteLists[index].stationId
        temp.lat = passRouteLists[index].lat
        temp.lng = passRouteLists[index].lng
        passRouteLists[index].stationId = passRouteLists[index + 1].stationId
        passRouteLists[index].lat = passRouteLists[index + 1].lat
        passRouteLists[index].lng = passRouteLists[index + 1].lng
        passRouteLists[index + 1].stationId = temp.stationId
        passRouteLists[index + 1].lat = temp.lat
        passRouteLists[index + 1].lng = temp.lng
        this.passRouteList = passRouteLists
        this.pointList = this.routeInfo.routePassPointList = this.startRouteList.concat(this.passRouteList, this.destinationRouteList)
      }
    },
    // 起始地 经由地和终点地下拉事件
    selectChange (item, route) {
      const { stationId, stationLng, stationLat } = item
      if (route === 'start') {        
        this.routeInfo.startLat=stationLat
        this.routeInfo.startLng=stationLng
        this.startRouteList.splice(0, 1, { routeId: this.routeInfo.routeId, routeNo: 0, stationId: stationId, lat: stationLat, lng: stationLng })
      } else if (route === 'passRoute') {
        // 匹配停留所id 获取停留所坐标
        let point = { lat: 0, lng: 0 }
        for (const x of this.stationDataList) {
          if (item.stationId === x.stationId) {
            point.lng = x.stationLng
            point.lat = x.stationLat
            break
          }
        }
        // 过滤掉空选项下拉框
        let arrs = this.passRouteList.filter(o => {
          if (o.stationId !== '') return o
        })
        // 获取当前路由经地的数组下标
        let i
        for (let index = 0; index < arrs.length; index++) {
          const element = arrs[index]
          if (item.stationId === element.stationId) {
            i = index
            break
          }
        }
        this.passRouteList.splice(i, 1, { routeId: this.routeInfo.routeId, routeNo: i + 1, stationId: item.stationId, lat: point.lat, lng: point.lng })
      } else if (route === 'destination') {
         this.routeInfo.endLat=stationLat
         this.routeInfo.endLng=stationLng

        // 获取开始地和经由地数组 两个数组的长度
        const getStartAndPassRouteList = this.startRouteList.concat(this.passRouteList)

        this.destinationRouteList.splice(0, 1, { routeId: this.routeInfo.routeId, routeNo: getStartAndPassRouteList.length, stationId: stationId, lat: stationLat, lng: stationLng })
      }
      // 开始地 + 经过地 + 终了地 = 最终结果集
      this.pointList = this.routeInfo.routePassPointList = this.startRouteList.concat(this.passRouteList, this.destinationRouteList)
      this.checkStationDuplicate()

    },
    // 重複チェック
    checkStationDuplicate(){
      console.log("checkStationDuplicate")
      console.log(this.pointList)
      // フラグリセット
      this.duplicateStationIdList = []
      this.startRouteDuplicateFlag = false
      this.destinationRouteDuplicateFlag = false
      for(let i = 0; i < this.passRouteListComp.length; i++){
        this.passRouteListComp[i].isDuplicated = false
      }
      // 使用されている停留所をループしてIDを比較 重複しているIDを格納
      for(let i = 0; i < this.pointList.length; i++){
        for(let j = 0; j < this.pointList.length; j++){
          if(i!=j){
            if(this.pointList[i].stationId === this.pointList[j].stationId){
              console.log("重複あり")
              this.duplicateStationIdList.push(this.pointList[i].stationId)
            }
          }
        }
      }
      // 重複IDを使ってどこで重複しているかを判定し、エラー表示用フラグを立てる
      for(let i = 0; i < this.duplicateStationIdList.length; i++){
        // 出発地重複チェック
        if(this.duplicateStationIdList[i] == this.startRouteInfo.stationId){
          console.log("出発地重複")
          this.startRouteDuplicateFlag = true
        }
        // 停留所重複チェック
        for(let j = 0; j < this.passRouteListComp.length; j++){
          if(this.duplicateStationIdList[i] == this.passRouteListComp[j].stationId){
            console.log("停留所"+ (j+1) + "重複")
            this.passRouteListComp[j].isDuplicated = true
          }
        }
        // 到着地重複チェック
        if(this.duplicateStationIdList[i] == this.destinationInfo.stationId){
          console.log("到着地重複")
          this.destinationRouteDuplicateFlag = true
        }
      }
    },
    // 停留所存在チェック
    checkStationExist(arr){
      console.log("checkStationExist")
      console.log(arr)
      let stationCount = 0
      this.stationCountError = false
      for(let i = 0; i < arr.length; i++){
        if(arr[i].officeFlag == 0){
          stationCount++
        }
      }
      if(stationCount === 0){
        this.dialogOptionRouter.text = this.stationCountErrorMessage
        this.showDialogRouter = true
        this.stationCountError = true
        this.$refs.dialogRouter.confirm().then(() => {
          this.showDialogRouter = false
        })
      }
    },

    showIllegalStationErrorMessage(){
        this.dialogOptionRouter.text = this.illegalStationErrorMessage
        this.showDialogRouter = true
        this.$refs.dialogRouter.confirm().then(() => {
          this.showDialogRouter = false
        })
    },
    saveRouter () {
      this.checkRoute = true
      this.$validator.validateAll().then(res => {
        if (res) {

          this.show = res
          const { createUser, ...option } = this.routeInfo
          const { routeId, displayRouteId, routeName, routeDistance, routeTotalTime, transportKind, routeType } = this.routeInfo
          let arr = []
          for (const i of this.routeInfo.routePassPointList) {
            for (const o of this.stationDataList) {
              if (i.stationId === o.stationId) {
                arr.push({
                  stationId: o.stationId,
                  stationName: o.stationName,
                  officeFlag: o.officeFlag
                })
              }
            }
          }
          // this.pointList = arr
          this.checkStationDuplicate()
          
          if(this.duplicateStationIdList.length === 0){
            // 停留所数エラーがあるなら中止
            this.checkStationExist(arr)
            if(!this.stationCountError){
              // 不正な停留所が含まれていたら中止
              if(!this.illegalStationError){
                // 展示数据
                this.$store.commit('SET_LOGININFO', { routeId, displayRouteId, routeName, routeDistance, routeTotalTime, routePassPointList: arr, flag: this.flag, transportKind, routeType})
      
                // 提交数据
                this.$store.commit('SET_LOGININFOS', option)
              }else{
                this.show = false
                this.showIllegalStationErrorMessage()
              }
            }else{
              this.show = false
            }
          }else{
            this.show = false
          }
        } else {
          this.show = false
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.body {
    flex-direction: column;
    margin: 20px 0px;
    display: flex;
    flex: 1;
    .headerDiv {
      flex: 0 0 5%;
    }
    .contentDiv {
      padding: 0px 8%;
      overflow: auto;
      flex: 1 1 0
    }
    .add {
        display: flex;
        justify-content: center;
        align-items: center;
        & > div {
            width: 230px;
            height: 50px;
            display: flex;
            flex-direction: row;
            & > .addIcon {
              background-color: #4aa5be;
              margin: 5px;
              width: 45px;
              height: 45px;
              border-radius: 40px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            & > .addFontSize {
                margin-left: 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                & > div {
                  font-size: 1.5em
                }
            }
        }
    }
    .bodyContext {
        height: 55px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .titile {
            color: black;
            font-size: 1.5em;
            font-weight: 600; // 字体粗度
        }
        .label {
            position: relative;
            display: flex;
            flex: 1.2;
            height: 100%;
            min-width: 100px;
            margin-right: 10px;
            background-color: #d9e0e6;
            justify-content: center;
            align-items: center;
            & > div > span {
              font-family: 'Noto Sans CJK JP';
              color: rgb(80, 80, 80);
              font-size: 15px;
              font-weight: 400;
            }
        }
        .context {
            display: flex;
            flex: 8;
            height: 100%;
            position: relative;
            .contextColumn1 {
              position: inherit;
              flex: 6;
            }
            .contextColumn2 {
              position: inherit;
              flex: 1;
              padding: 0px 10px;
              display: flex;
              justify-content:center;
              align-items:Center;
              min-width: 100px;
              & > div {
                width:100px;
                position: inherit;
                display: flex;
                flex-direction: row;
                height: 100%;
                cursor: pointer;
                .controlButton {
                  width: 50%;
                  margin: auto 5px;
                  // appearance: button;
                }
              }
            }
            .selectId {
                // 清除select聚焦时候的边框颜色
                outline: none;
                height: 100%;
                width: 100%;
                // 文本缩进
                text-indent: 10px;
                border-radius: 10px;
                // 隐藏select的下拉图标
                -moz-appearance: none;
                -webkit-appearance: none;
                background: url('../../assets/dropselect.png') no-repeat scroll right center transparent;
                font-weight: 500;
                font-size: 1.5em;
            }
            .clear {
              position: absolute;
              width: 20px;
              height: 20px;
              top: 15px;
              right: 30px;
              background-color: #8f908b;
              border-radius: 50%;
              display: flex;
              justify-content:center;
              align-items:Center;
              cursor: pointer;
              .clearIcon {
                background-color: white;
                width: 13px;
                height: 2px;
              }
            }
        }
    }
    .info {
        padding: 5px 10px;
    }
    .foot {
      flex: 0 0 100px;
      width: 80%;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      & > div {
        width: 100%;
        padding: 0 60px;
      }
      .foot-btn {
        height: 50px;
        border-radius: 10px;
        border: 0px;
        width: 100%;
        background: linear-gradient(#70b6ca 50%, #48a3be 50%);
        // line-height: 55px;
        text-align: center;
        & > span {
          color: white;
          font-size: 1.6em;
          font-weight: 300; // 字体粗度
        }
      }
    }
}
.T7-radius {
    width: 100%;
    height: 100%;
    background: rgb(109, 109, 109);
    border-radius: 30px;
    color: #ffffff;
    text-align: center;
    font-size: 17px;
    padding: 0;
    border: solid 1px;
}
.inputstyles {
    width: 100%;
    height: 100%;
    line-height: 20px;
    font-size: 1.5em;
    text-align: left;
    border-radius: 0px;
    padding-left: 10px;
}
.idClass {
    height: 100%;
    width: 45%;
    background-color: #f0f0f0;
    & > div {
        font-size: 26px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        padding-left: 10px;
        padding-top: 5px;
        // left: 0%
    }
}
.gooleMap {
  width: 99%;
  height: 500px;
  margin: 0 10px;
}
#editRouteMapID {
  width: 100%;
  height: 100%;
}
.req {
  text-align: left;
  // 文字缩进
  text-indent: 3em;
}
.icon {
  left: 10px;
  position: absolute;
  color :black;
    font-size: 1.6em;
}
.errorMessage {
  color: red;
}
.idClass {
    height: 100%;
    width: 45%;
    // border: 1px solid black;
    background-color: #f0f0f0;
    & > div {
        font-size: 26px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        padding-left: 10px;
        padding-top: 5px;
        // left: 0%
    }
}
.radiodiv {
  border-radius: 10px;
  width: 300px;
  height: 45px;
  margin-top: 5px;
  text-align: center;
  font-size: 18px;
}
.radiobutton {
  height: 30px;
  width: 30px;
}
input[type="radio"] + span {
  display: inline-block;
  width: 10px;
  vertical-align: middle;
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/router/views/EditRouterInfo.vue